import React from 'react';
import RichTextContent, { RichTextContentProps } from './RichTextContent';

const Heading5 = ({ node }: RichTextContentProps) => {
  return (
    <h5>
      <RichTextContent node={node} />
    </h5>
  );
};

export default Heading5;
